import React from "react";
import { createRoot } from "react-dom/client";
import "@fontsource/space-grotesk/400.css";
import "@fontsource/space-grotesk/500.css";
import "@fontsource/space-grotesk/600.css";
import "@fontsource/ibm-plex-mono/400.css";
import "./styles.css";
import "./machine.css";
import "./brand.css";
import "./assurance-dialog.css";
import "./thread-dialog.css";
import "./audit-evidence.css";
import "./simulator-alert.css";
import "./twin-qr.css";
import { App } from "./App.jsx";
import { DocumentationPage } from "./DocumentationPage.jsx";
import { DatasetValidationPage } from './DatasetValidationPage.jsx';

const page = window.location.pathname === '/validate-dataset'
  ? <DatasetValidationPage />
  : window.location.pathname === "/docs" || window.location.pathname.startsWith("/docs/")
  ? <DocumentationPage />
  : <App />;

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    {page}
  </React.StrictMode>
);
